module.exports = __webpack_public_path__ + "static/media/Qentaz.5560ea92.png";